import React, { useState } from "react";
import { Container, Form } from "reactstrap";
import { useFormik } from "formik";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useHistory, useParams } from "react-router-dom";
import ResultHandler from "../../../components/ResultHandler";
import FormButtonHandler from "../../../components/FormButtonHandler";
import { useResponse } from "../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import { useGetInstence } from "../../../hooks/useGetInstence";
import { WORK_EXPERIENCE_FIELDS } from "./CONSTANT";
import * as Yup from "yup";
import WorkExperienceForm from "./WorkExperienceForm";
import {
  editWorkExperience,
  getSingleWorkExperience,
} from "../../../api/workExperience";

const TYPES = {
  'select': null,
  'add-more': [],
  'checkbox': false,
  'file' : null,
  'date': null
}

const initialValues = {};
const FIELDS_VALIDATION = {};

WORK_EXPERIENCE_FIELDS.forEach((f) => {
  initialValues[f.key] = TYPES[f.type] || "";
  if (f.type == "file") {
    FIELDS_VALIDATION[f.key + "_preview"] = Yup.string().required(
      "This Field Is Required"
    );
  } else if (f.type == "select" && f.isMulti) {
    FIELDS_VALIDATION[f.key] = Yup.array();
  } else {
    FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required");
  }
});

const EditWorkExperience = () => {
  let navigate = useHistory();
  const { t } = useTranslation();
  const params = useParams();

  const [editedWorkExperience, setEditedWorkExperience] = useState(null);

  const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
    getSingleWorkExperience,
    params.id,
    (response) => {
      setEditedWorkExperience({
        ...response.data.data.experience,
      });
    }
  );

  const { setData, loading, error, success } = useResponse(editWorkExperience, () => {
    navigate.goBack()
  });

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      ...editedWorkExperience,
    },
    validationSchema: Yup.object(FIELDS_VALIDATION),
    onSubmit: (values) => {
      // console.log(values);
      setData({ type: "edit", id: params.id, data: values });
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={t("Work Experience")}
            breadcrumbItem={t("btns.Edit") + " " + t("Work Experience")}
          />

          {editedWorkExperience && (
            <Form
              className="needs-validation"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <WorkExperienceForm validation={validation} />

              <FormButtonHandler btnTxt="Edit" loading={loading} />
            </Form>
          )}

          <ResultHandler
            loading={instenceLoading}
            error={error}
            success={success}
            successMsg={"Updated Successfully!"}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EditWorkExperience;
